import { numberFormat } from '@lib/helpers'
import { Container } from '@styles/global.styled'
import { useState } from 'react'
import useInvestorStatistics from '@hooks/useInvestorStatistics'
import StatisticItems from '../StatisticItems'
import SuburbProfileFilters from '../SuburbProfileFilters'
import * as S from './InvestorStatistics.styled'

const InvestorStatistics = ({
  suburb,
  investorStats: initialInvestorStats,
  slug,
  availableBedrooms,
}) => {
  const [bedrooms, setBedrooms] = useState('Overall')
  const { investorStats } = useInvestorStatistics(
    slug,
    bedrooms,
    initialInvestorStats
  )

  const investerStatisticsData = [
    {
      title: 'Median rental price for Houses',
      subTitle: '(all agencies, last 12 months)',
      value: investorStats?.house?.median_rent
        ? `${numberFormat(investorStats.house.median_rent, '$')}pw`
        : null,
    },
    {
      title: 'House rental price change',
      subTitle: '(all agencies, last 12 months)',
      value: investorStats?.house?.median_rent_change
        ? `${investorStats.house.median_rent_change}%`
        : null,
    },
    {
      title: 'Median rental price for Units',
      subTitle: '(all agencies, last 12 months)',
      value: investorStats?.unit?.median_rent
        ? `${numberFormat(investorStats.unit.median_rent, '$')}pw`
        : null,
    },
    {
      title: 'Unit rental price change',
      subTitle: '(all agencies, last 12 months)',
      value: investorStats?.unit?.median_rent_change
        ? `${investorStats.unit.median_rent_change}%`
        : null,
    },
    {
      title: 'Average rental yield for Houses',
      subTitle: '(all agencies, last 12 months)',
      value: investorStats?.house?.rental_yield
        ? `${investorStats.house.rental_yield}%`
        : null,
    },
    {
      title: `Average rental yield for Units`,
      subTitle: '(all agencies, last 12 months)',
      value: investorStats?.unit?.rental_yield
        ? `${investorStats.unit.rental_yield}%`
        : null,
    },
    {
      title: `${suburb} total population size`,
      subTitle: '(as at the last census)',
      value: initialInvestorStats?.population
        ? numberFormat(initialInvestorStats.population)
        : null,
    },
    {
      title: `Median household size in ${suburb}`,
      subTitle: '(as at the last census)',
      value: initialInvestorStats?.household_size,
    },
  ]

  return investerStatisticsData.filter((it) => it.value)?.length > 0 ? (
    <S.InvestorStatistic>
      <Container>
        <S.InvestorStatisticTitle>
          {suburb.toUpperCase()} INVESTOR STATISTICS
          <SuburbProfileFilters
            bedrooms={bedrooms}
            onBedroomsChange={setBedrooms}
            availableBedrooms={availableBedrooms}
          />
        </S.InvestorStatisticTitle>

        <StatisticItems
          statistics={investerStatisticsData.filter((it) => it.value)}
        />
        <S.Note>
          (Median House Price and Median Unit Price is calculated based on
          leased properties
          {bedrooms !== 'Overall'
            ? ` with ${bedrooms} ${bedrooms === '1' ? 'bedroom' : 'bedrooms'}`
            : ' with all numbers of bedrooms'}
          )
        </S.Note>
      </Container>
    </S.InvestorStatistic>
  ) : null
}

export default InvestorStatistics
